import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=357ac0a6&"
import script from "./IconBack.vue?vue&type=script&lang=js&"
export * from "./IconBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357ac0a6')) {
      api.createRecord('357ac0a6', component.options)
    } else {
      api.reload('357ac0a6', component.options)
    }
    module.hot.accept("./IconBack.vue?vue&type=template&id=357ac0a6&", function () {
      api.rerender('357ac0a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconBack.vue"
export default component.exports